'use client';

import { ConditionalWrapper } from '@packages/shared/src/ui/ConditionalWrapper/ConditionalWrapper';
import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import { useRef } from 'react';
import { ComponentTypes } from '../../../interfaces';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import { LinkWrapper } from './components/LinkWrapper.client';
import { MainHeadline } from './components/MainHeadline.client';
import { SubHeadline } from './components/SubHeadline.client';
import type { HeadlineProps } from './types';

const headlineStyles = cva('mx-0', {
  variants: {
    marginVariant: {
      big: 'my-[1.5rem]',
      medium: 'my-[0.75rem]',
      small: 'my-[0.25rem]',
      none: 'my-0',
    },
  },
});

export const CmsHeadline = ({ data, className }: HeadlineProps) => {
  const {
    field_margin_variant: marginVariant = 'none',
    field_link: fieldLink,
    field_text_subheadline: subHeadlineText,
    field_tracking: tracking,
  } = data;

  const headlineRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={headlineRef}
      className={clsx(className, headlineStyles({ marginVariant }))}
      data-tracking={tracking}
    >
      <ConditionalWrapper condition={!!fieldLink} wrapper={LinkWrapper({ data, headlineRef })}>
        <>
          <MainHeadline data={data} />
          {subHeadlineText && <SubHeadline data={data} />}
        </>
      </ConditionalWrapper>
    </div>
  );
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.Headline]: CmsHeadline });
